import React from 'react';
import { Link } from 'react-router-dom';
import TypeNav from './type_nav';

import './bnb_header.css';

export default class BnbHeader extends React.Component {
    render() {
        const { site } = this.props;

        let linkNav = [{status: false, value: 'Angebote', path: '/'}, {status: false, value: 'Gesuche', path: '/gesuche'}];
        if(site === 'angebote') linkNav[0].status = true;
        if(site === 'gesuche') linkNav[1].status = true;

        return (
            <div className={'bnb_header'}>
                <TypeNav items={linkNav} />
                <Link to={'/inserieren'} className={'create_new_btn'}>Angebote/Gesuche eintragen</Link>
            </div>

        )
    }
}